import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Icon from "src/components/Icon";
import TemplatePreview from "../TemplatePreview";
import styles from "./templateCard.module.scss";

interface TemplateCardProps {
  name: string | undefined;
  image: string | undefined;
  // template: TemplateType | null;
}

const TemplateCard: React.FC<TemplateCardProps> = ({
  name,
  image,
  // template,
}) => {
  const [show, setShow] = useState(false);

  return (
    // <div
    //   className={`${styles["templateCard"]} ${name !== name ? `bg-4` : `hover:bg-3`}`}
    //   // onClick={() => setClickedTemplate(template)}
    // >
    <div
      className={`${styles["templateCard"]} bg-4`}
      // onClick={() => setClickedTemplate(template)}
    >
      <div className={styles["templateCard__container"]}>
        <div className="flex items-center gap-4 md:w-full md:justify-between md:gap-0">
          <div className={`${styles["templateCard__image"]} border shadow`}>
            {image ? (
              <LazyLoadImage
                src={image}
                placeholderSrc={image}
                alt="template"
                effect="blur"
                width="100%"
                height="100%"
                className="rounded-md"
              />
            ) : (
              <></>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <h3 className={styles["templateCard__heading"]}>{name}</h3>
            {/* <div className={styles["templateCard__indicator"]}></div> */}
          </div>
        </div>
        <div className={styles["templateCard__preview"]}>
          <div
            className={styles["templateCard__preview-button"]}
            onClick={() => setShow(true)}
          >
            <p>Preview</p>
            <span>
              <Icon iconName="preview" />
            </span>
          </div>
          <TemplatePreview show={show} setShow={setShow} />
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
